exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#spectrum-chart{width:100%;position:relative}", ""]);

// exports
